import React from 'react';
import Seo from 'shared/seo/Seo';
import { buildBreadcrumbJsonLd } from 'shared/seo/jsonLd';
import { useTranslation } from 'react-i18next';
import BlogList from '../components/BlogList';
import PageHeader from '../../common/PageHeader/PageHeader';  
 import ContactCTA from 'features/common/ContactCTA';
import { getCanonicalUrl, pageMeta } from 'shared/seo/seoMeta';
const BlogListPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      {/*
        The old <meta name="keywords"> here listed "HVAC blog, climatisation…" —
        a different industry entirely, left over from a template. Google has
        ignored the keywords meta since 2009 anyway, so it is simply dropped.
      */}
      <Seo
        title={pageMeta.blog.title}
        description={pageMeta.blog.description}
        canonical={getCanonicalUrl(pageMeta.blog.canonicalPath)}
        jsonLd={[
          buildBreadcrumbJsonLd([
            { name: 'Accueil', path: '/' },
            { name: t('nav.blog', 'Blog'), path: '/blog' },
          ]),
        ]}
      />
    <PageHeader
        title={t('blog.title')}
        subtitle={t('blog.subtitle')}
      />
      <BlogList />
     
        <ContactCTA />
    </>
  );
};

export default BlogListPage;
